<template>
  <v-container fluid fill-height justify-center id="scrolling-techniques-7" class="overflow-y-auto" key="remind">
    <transition name="router-anim" mode="out-in">
      <v-row class="max-w" v-if="status === 'success'" key="1">
        <v-col class="px-7">
          <div class="display-1 font-weight-medium mb-3">
            {{ $t('konto-akt-tytul') }}
          </div>
          <div class="font-weight-light mb-4 c-lighter-1">
            {{ $t('konto-akt-opis') }}
          </div>
          <div class="pt-4">
            <v-btn x-large class="btn-secondary mb-3" to="/login">{{ $t('zaloguj') }}</v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row class="max-w" v-else-if="status === 'error'" key="2">
        <v-col class="px-7 text-center">
          <v-icon large>mdi-wifi-off</v-icon>
          <div class="display-1 font-weight-medium my-3">
            {{ $t('blad') }}
          </div>
          <div class="font-weight-light mb-4 c-lighter-1">
            {{ $t(error_code) }}
          </div>
        </v-col>
      </v-row>
      <v-row class="max-w" v-else key="3">
        <v-col class="px-7">
          <div class="display-1 font-weight-medium mb-4">
            {{ $t('konto-czekaj-tytul') }}
          </div>
          <div class="font-weight-light mb-4 c-lighter-1">
            {{ $t('konto-czekaj-opis') }}
          </div>
          <v-progress-linear
            indeterminate
            color="teal"
          ></v-progress-linear>
        </v-col>
      </v-row>
    </transition>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data: () => ({
    status: 'wait',
    error_code: 0,
  }),
  computed: {
    token() {
      return this.$route.params.token
    }
  },
  created () {
    this.unauth();

    if (!this.token) {
      this.error_code = 9;
      this.status = 'error';
    } else {
      this.postForm();
    }
  },
  methods: {
    ...mapActions([
      'unauth'
    ]),
    postForm () {
      const formData = new URLSearchParams();
      formData.append('token', this.token);
      this.$store.dispatch('confirm', formData)
      .then(res => {
        if (res.error) {
          this.error_code = res.error.code;
          this.status = 'error';
        } else {
          this.status = 'success';
        }
      });
    }
  }
}
</script>